import * as stylex from "@stylexjs/stylex";
import "../tokens.stylex.ts";
import { color, font, fontSize, media, motion, radius, shadow, space } from "../tokens.stylex.ts";

/** Shared look for text inputs, textareas and select triggers. */
export const controlStyles = {
  base: {
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    kMv6JI: "x1wv6yj",
    kGuDYH: "xluwven xjvj451",
    kMwMTN: "x9aqtqa",
    kWkggS: "x1paulmi xu6btn8",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x4bnxre x1e1nhgj x1tq5463",
    kaIpWk: "xoazux2",
    kGVxlE: "xwgq1kd x148f31q",
    kI3sdo: "x1a2a7pz",
    k1ekBW: "x12zzom9",
    kIyJzY: "x7updtu",
    k8Qsv1: "xhgda16",
    $$css: true
  },
  input: {
    kZKoxP: "x90ne7k x8tjdam",
    kg3NbH: "xsef1i0",
    $$css: true
  },
  textarea: {
    k8WAf4: "x1imsgqj",
    kg3NbH: "xsef1i0",
    kHenm0: "x288g5",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  mono: {
    kMv6JI: "xxg9qwl",
    kGuDYH: "xket8oi xjvj451",
    kb6lSQ: "xjat59b",
    $$css: true
  },
  invalid: {
    kVAM5u: "x1tv6h2l x19p0tjb x1pv6jhi",
    kGVxlE: "xwgq1kd x1r3rcwx",
    $$css: true
  }
};